import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Camera } from '@liveauctioneers/hammer-ui-core/icons';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { SEARCH_BY_IMAGE_TRIGGER_ID } from './components/SearchByImageEducationPopover';
import { useSearchByImageSurface } from './hooks/useSearchByImageSurface';

/**
 * treatmentb entry point: a camera IconButton rendered inside the right of the header
 * search input (as its endAdornment). Opens the shared upload popover (desktop) / bottom
 * sheet (mobile). Only mounted for treatmentb; exposure is owned by HammerHeader.
 */
export const SearchByImageInputAdornment = () => {
    const formatMessage = useAppFormatMessage();
    const { containerRef, education, isOpen, onTriggerClick, surface } = useSearchByImageSurface();

    return (
        <div
            className="relative flex items-center"
            ref={containerRef}
        >
            <IconButton
                aria-expanded={isOpen}
                aria-haspopup="dialog"
                aria-label={String(formatMessage(['visualSearch', 'searchByImage']))}
                hideTooltip
                icon={Camera}
                id={SEARCH_BY_IMAGE_TRIGGER_ID}
                onClick={onTriggerClick}
                size="sm"
                style="neutral"
                type="button"
                variant="transparent"
            />
            {education}
            {surface}
        </div>
    );
};
